// msapBridge-retouch.js?v=6.0.43
import { getNormalizedOrEmpty } from './msapBridge-loader.js';

function isAddonVisible(addon, productId, categoryIds) {
    const mode = (addon.include_exclude || 'none').trim();
    if (mode === 'none' || !mode) return true;

    const pid = productId ? String(productId) : null;
    const cats = Array.isArray(categoryIds) ? categoryIds.map(String) : [];

    const inProducts = pid && addon.for_product_ids?.includes(pid);
    const catOverlap = (cats.length && addon.for_category_ids?.length)
        ? addon.for_category_ids.some(id => cats.includes(String(id)))
        : false;

    switch (mode) {
        case 'include_products': return !!inProducts;
        case 'exclude_products': return !inProducts;
        case 'include_categories': return !!catOverlap;
        case 'exclude_categories': return !catOverlap;
        default: return true;
    }
}

/** Returns unique visible retouch slugs (e.g. ["basic","pro"]). */
export async function getVisibleRetouchValues({ productId = null, categoryIds = [] } = {}) {
    const normalized = await getNormalizedOrEmpty();
    const out = new Set();

    (normalized.groups || []).forEach(group => {
        const isRetouchGroup =
            (group.mscp_mapping && String(group.mscp_mapping).trim() === 'retouch') ||
            (String(group.map_attribute || '').trim() === 'pa_retouch');
        if (!isRetouchGroup) return;

        (group.products || []).forEach(addon => {
            if (!isAddonVisible(addon, productId, categoryIds)) return;
            (addon.variations || []).forEach(v => {
                const slug = v.attrs?.['pa_retouch'];
                if (slug) out.add(String(slug));
            });
        });
    });

    return Array.from(out);
}